interface StatusMessageProps {
  success: boolean;
  successMsg: string;
  failureMsg: string;
}
const StatusMessage: React.FC<StatusMessageProps> = ({
  success,
  successMsg,
  failureMsg,
}) => {
  return (
    <div
      style={{
        maxWidth: "300px",
        position: "fixed", // Independent of document flow, always fixed on screen
        top: "50%", // Vertically aligns the component in the center
        left: "50%", // Horizontally aligns the component in the center
        transform: "translate(-50%, -50%)", // Perfectly centers it
        zIndex: 9999, // Highest z-index to appear above everything
        backgroundColor: success ? "#dad9ef" : "#ffcccc", // White background
        padding: "20px", // Adds padding around the content
        borderRadius: "10px", // Rounded corners
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)", // Slight shadow for visual depth
        textAlign: "center", // Centers the text inside the box
        fontFamily: "Arial, sans-serif", // Sets the font
        fontSize: "18px", // Font size
        color: success ? "#333" : "#fff", // Text color
      }}
    >
      {success ? successMsg : failureMsg}
    </div>
  );
};

export default StatusMessage;
